import http from '@/http';

export default class AreaService {


	getAreas() {
		console.log('getAreas ...');
		return http.get('area').then(res => res.data);
    }

	update(area) {
		console.log('update ...');
		return http.put(`area/${area.id}`, area).then(res => res.data);
    }

	create(area) {
		console.log('create ...');
		return http.post('area', area).then(res => res.data);
    }

	delete(area) {
		console.log('create ...');
		return http.delete(`area/${area.id}`).then(res => res.data);
    }

}
